import styled from 'styled-components';

export const SrpcardOuterWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;
`,
);
